import {MapPoint} from "./map.component";
import LatLng = google.maps.LatLng;
import OverlayView = google.maps.OverlayView;
import InfoWindow = google.maps.InfoWindow;
import Map = google.maps.Map;

export const createEVAMarkersOverlay = (map: google.maps.Map, points: MapPoint[], centerOnClick?: boolean) => {
	class CustomOverlay extends OverlayView {
		private markerPoints: any[];
		private infoWindow: InfoWindow;
		private centerOnClick: boolean = false;

		constructor() {
			super();
			this.markerPoints = points;
			this.setMap(map);
			this.infoWindow = new InfoWindow();
			this.centerOnClick = centerOnClick;
		}

		onAdd() {
			var panes = this.getPanes();
			this.markerPoints.forEach((markerPoint: MapPoint) => {
				let markerDiv = this.createMarkerElement(markerPoint);
				panes.overlayMouseTarget.appendChild(markerDiv);
				this.addMarkerListeners(markerPoint, markerDiv);
				markerPoint.markerElement = markerDiv;
				if(markerPoint.isActive) this.openPoiInfoWindow(markerPoint);
			});
		}

		createMarkerElement(markerPoint: MapPoint) {
			let icon = markerPoint.pointIcon || 'poi';
			let div = document.createElement('div');
			div.innerHTML = '<div class="eva-3-marker -eva-3-shadow-1 -poi-marker ' + (markerPoint.isActive ? '-active' : '') + '"><div class="marker-container"><i class="eva-3-icon-' + icon + '"></i></div></div>';
			div.style.position = 'absolute';
			div.style.cursor = 'pointer';
			return div;
		}

		addMarkerListeners(markerPoint: MapPoint, markerDivElement): void {
			let self = this;
			google.maps.event.addDomListener(markerDivElement, "click", function (event: MouseEvent) {
				self.infoWindow.close();
				self.markerPoints.forEach(function (marker) {
					self.setInactive(marker.markerElement);
				});
				this.querySelector(".-poi-marker").classList.add("-active");
				if (self.centerOnClick) {
					let map = self.getMap() as Map;
					map.panTo(new LatLng(markerPoint.location.latitude, markerPoint.location.longitude));
				}
				self.openPoiInfoWindow(markerPoint);
			});
		}

		setInactive(markerDivElement): void {
			markerDivElement.querySelector(".-poi-marker").classList.remove("-active");
		}

		draw() {
			this.markerPoints.forEach((marker) => {
				var point = this.getProjection().fromLatLngToDivPixel(new LatLng(marker.location.latitude, marker.location.longitude));

				if (point) {
					marker.markerElement.style.left =  (point.x - 16) + 'px';
					marker.markerElement.style.top = (point.y + 1) + 'px';
				}
			});

		}

		onRemove() {

		}

		openPoiInfoWindow(markerPoint): void {
			if(markerPoint.infoWindowContent) {
				let markerPointLatLng = new LatLng(markerPoint.location.latitude, markerPoint.location.longitude);
				this.infoWindow.setContent(markerPoint.infoWindowContent);
				this.infoWindow.setPosition(markerPointLatLng);
				this.infoWindow.open(this.getMap());
			}
		}
	}

	return new CustomOverlay();
};
